import type { OwnerProfile } from '../../types/docops';

const now = new Date().toISOString();

export const SEED_OWNER_PROFILE: OwnerProfile = {
  ownerId: 'stan',
  structureRationale: 'trust-ip-licensing',
  operationalRole: 'none',
  protectionNeeds: [
    'asset-protection',
    'estate-planning',
    'income-continuity',
    'clean-separation',
    'acquisition-leverage',
  ],
  trustStructure: {
    trustName: '[Family] Trust',
    trusteeName: '[TBD - attorney or professional]',
    beneficiaries: ['wife', 'children'],
    rationale:
      'Estate planning and asset protection - trust owns all IP, licenses to operating entities for royalty income',
    restrictions: [
      'Owner has NO equity in any operating entity',
      'Owner has NO officer or director role',
      'Owner has NO operational responsibilities',
      'Owner is NOT a signatory on any healthcare company',
      'Owner is available informally for product guidance only - no contractual obligation',
      'All healthcare contracts signed by independent CEO',
      'Trust receives licensing royalties as priority operating expense',
      'Change of control clause in all license agreements - trust consents to any acquisition',
      'IP improvements during license term revert to trust',
    ],
  },
  otherEntities: [
    {
      name: 'Medek Health',
      relationship: 'Active RPM business, break-even',
      separationRequired: true,
      notes:
        'No shared bank accounts, employees, contractors, vendors, contracts, or financial transfers between Medek and any trust-licensed entity',
    },
  ],
  keyRelationships: [
    {
      name: 'Kevin Wallquist',
      role: 'Intended CEO of Hemo Tech LLC',
      status: 'Interested, pending full disclosure and formal agreement',
    },
    {
      name: 'Dr. Calapai',
      role: 'Medical Director, PC owner (CC Medical PC)',
      status: 'Engaged, needs compliance addendum and formal agreement',
    },
    {
      name: '[Defense Attorney]',
      role: 'Legal counsel - has approved business plan and trust structure concept',
      status: 'Active, needs to review final trust documents',
    },
    {
      name: '[Trust/Estate Attorney]',
      role: 'Trust establishment and IP assignment',
      status: 'TBD - needs to be engaged',
    },
  ],
  planningNotes:
    '8-month sprint to acquisition. Trust collects dual royalty streams from Hemo Tech (consumer platform) and Med Co Maker (B2B SaaS). Kevin and MeMD alumni team execute playbook proven at MeMD / Walmart Health. Compliance infrastructure exceeds most Series B companies. All documents designed for acquisition portability - generic entity references, assignable contracts, clean IP chain of title.',
  preferences: {
    defaultStructure: 'trust-ip-licensing',
    defaultOperationalRole: 'none',
    defaultProtections: [
      'trust-licensing-with-change-of-control',
      'no-owner-equity-in-operating-entity',
      'no-owner-operational-role',
      'mandatory-distributions-to-trust',
      'entity-separation-from-other-businesses',
      'acquisition-portability',
      'income-continuity-if-unavailable',
    ],
  },
  createdAt: now,
  updatedAt: now,
};
